module.exports = __webpack_public_path__ + "img/box-1-ht.3068d112.png";